import React, { useContext, useMemo, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";

export default function FancyHeader({
  brand,
  plan,
  searchValue = "",
  onSearch = () => {},
  suggestions = [],
  onPickSuggestion = () => {},
  onNewPlan = () => {},
}) {
  const crumbs = [
    { label: "Outdoor Planning Tool", href: "/" },
    brand ? { label: brand.name, href: "#" } : null,
    plan ? { label: plan.meta?.campaign, href: "#" } : null,
  ].filter(Boolean);

  const { loggedIn, userData, setLoggedIn, setUserData, getLoggedIn } = useContext(AuthContext);
  // be defensive about user shape
  const user = userData?.user || userData?.user?.user || userData || {};
  const name = user?.user?.username || user?.user?.name || user?.username || user?.name || "";
  const imageURL = user?.user?.imageURL || user?.imageURL || "";
  const isViewer = (user?.user?.role || user?.role) === "viewer";
  const initials = useMemo(
    () => (name?.trim()?.[0] ? name.trim()[0].toUpperCase() : "U"),
    [name]
  );

  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleLogout = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Önce menüyü kapat
    setMenuOpen(false);

    // LocalStorage'ı temizle
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("auth-token");
      localStorage.removeItem("user");
    } catch (err) {
      /* ignore */
    }

    // Auth state'ini güncelle
    setLoggedIn?.(false);
    setUserData?.(null);

    // Context'i senkronize et
    if (getLoggedIn) {
      await getLoggedIn();
    }

    // Login sayfasına yönlendir
    history.push("/login");
  };

  // Menü dışına tıklandığında menüyü kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Logout butonuna tıklanmışsa, menüyü kapatma
      const logoutButton = event.target.closest('button');
      if (logoutButton && logoutButton.textContent.includes('Çıkış Yap')) {
        return;
      }

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      {loggedIn ? (
        <header className="sticky top-0 z-40">
          <div className="h-1 bg-gradient-to-r from-brand-500 via-sky-500 to-emerald-500" />
          <div className="bg-white/90 backdrop-blur border-b border-slate-200">
            <div className="container py-3 flex items-center justify-between gap-4">
              {/* Left: logo + crumbs */}
              <div className="flex items-center gap-4 min-w-0">
                <button
                  onClick={() => history.push("/homepage")}
                  className="h-10 w-10 rounded-xl grid place-items-center overflow-hidden"
                  aria-label="Ana Sayfa"
                >
                  {/* <img src="https://i.imgur.com/xzASkm3.png" alt="logo" className="h-full w-full object-contain" /> */}
                  <img src="https://media.licdn.com/dms/image/v2/D560BAQHVwb49l3Xr3Q/company-logo_200_200/company-logo_200_200/0/1699889199212/initiative_de_logo?e=1785369600&v=beta&t=KXx4kYLbu1gU05XF6-JZi_h0WYC8hYaNmUT3yIZF2T4" alt="logo" className="h-full w-full object-contain" />
                  {/* <img src="https://initiative.com/wp-content/uploads/2023/11/cropped-Initiative_RGB_OffWhite.png" alt="logo" className="h-full w-full object-contain" /> */}
                  {/* <img src="https://www.interpublic.com/wp-content/themes/ipg/_include/img/logo.svg" alt="logo" className="h-full w-full object-contain" /> */}
                </button>

                <nav className="hidden sm:flex items-center gap-2 text-sm text-slate-600 overflow-hidden">
                  {crumbs.map((c, i) => (
                    <div key={i} className="flex items-center gap-2 shrink-0">
                      <a
                        href={c.href}
                        onClick={(e) => {
                          if (c.href === "/") {
                            e.preventDefault();
                            history.push("/homepage");
                          }
                        }}
                        className={`truncate ${i === crumbs.length - 1 ? "text-ink font-medium" : "hover:text-ink"}`}
                      >
                        {c.label}
                      </a>
                      {i < crumbs.length - 1 && <span className="text-slate-300">/</span>}
                    </div>
                  ))}
                </nav>
              </div>

              {/* Center: optional search (kept compact) */}
              {/* <div className="flex-1 px-4 max-w-xl">
                <div className="hidden sm:flex items-center bg-white border border-slate-200 rounded-lg px-3 h-10 shadow-sm">
                  <svg width="16" height="16" viewBox="0 0 24 24" className="text-slate-400 me-2">
                    <path
                      fill="currentColor"
                      d="M15.5 14h-.79l-.28-.27A6.5 6.5 0 1 0 14 15.5l.27.28v.79l5 5l1.5-1.5l-5-5m-6 0A4.5 4.5 0 1 1 14 9.5A4.5 4.5 0 0 1 9.5 14Z"
                    />
                  </svg>
                  <input
                    value={searchValue}
                    onChange={(e) => onSearch(e.target.value)}
                    placeholder="Kampanya ara"
                    className="outline-none text-sm placeholder:text-slate-400 flex-1"
                  />
                  {searchValue && (
                    <button onClick={() => onSearch("")} className="text-slate-400 hover:text-slate-600 text-sm">
                      temizle
                    </button>
                  )}
                </div>
              </div> */}

              {/* Right: actions */}
              <div className="flex items-center gap-3">
                {!isViewer && (
                  <button
                    onClick={() => {
                      onNewPlan();
                      history.push("/NewPlan");
                    }}
                    className="h-10 px-3 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 shadow-subtle whitespace-nowrap"
                  >
                    + Yeni Plan
                  </button>
                )}

                <div className="relative" ref={menuRef}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuOpen((s) => !s);
                    }}
                    className="h-10 px-3 rounded-lg border flex items-center gap-2 bg-white"
                    aria-haspopup="true"
                    aria-expanded={menuOpen}
                  >
                    {imageURL ? (
                      <img src={imageURL} alt={name || "avatar"} className="h-8 w-8 rounded-full object-cover" />
                    ) : (
                      <div className="h-8 w-8 rounded-full bg-slate-200 grid place-items-center text-sm font-medium text-slate-700">
                        {initials}
                      </div>
                    )}
                    <span className="hidden sm:inline text-sm text-slate-700 truncate max-w-[100px]">{name || "Kullanıcı"}</span>
                  </button>

                  {menuOpen && (
                    <div
                      className="absolute right-0 mt-2 w-44 bg-white border border-slate-200 rounded shadow-lg overflow-hidden z-50"
                      onClick={(e) => e.stopPropagation()}
                    >

                      <hr />
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-3 py-2 text-sm text-rose-600 hover:bg-slate-50"
                      >
                        Çıkış Yap
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </header>
      ) : null}
    </>
  );
}
